var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-driver-banner"},[_c('div',{staticClass:"content-driver-banner__text",domProps:{"innerHTML":_vm._s(_vm.bannerContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }